import enums from 'goodeggs-purchase-orders-sdk/enums';

export default angular
  .module('filters.formatStatus', [])

  .filter(
    'formatStatus',
    () =>
      function(status) {
        if (status != null) {
          return enums.titleCase(status);
        }
      },
  );
